// Auto-generated JS AJAX components map

import AJAX_Applications from "./JavaScript/AJAX_Applications.jsx";
import AJAX_ASP from "./JavaScript/AJAX_ASP.jsx";
import AJAX_Database from "./JavaScript/AJAX_Database.jsx";
import AJAX_Examples from "./JavaScript/AJAX_Examples.jsx";
import AJAX_Intro from "./JavaScript/AJAX_Intro.jsx";
import AJAX_PHP from "./JavaScript/AJAX_PHP.jsx";
import AJAX_Request from "./JavaScript/AJAX_Request.jsx";
import AJAX_Response from "./JavaScript/AJAX_Response.jsx";
import AJAX_XMLHttp from "./JavaScript/AJAX_XMLHttp.jsx";
import AJAX_XML_File from "./JavaScript/AJAX_XML_File.jsx";

const jsAjaxComponentsMap = {
  "<AJAX_Applications />": AJAX_Applications,
  "<AJAX_ASP />": AJAX_ASP,
  "<AJAX_Database />": AJAX_Database,
  "<AJAX_Examples />": AJAX_Examples,
  "<AJAX_Intro />": AJAX_Intro,
  "<AJAX_PHP />": AJAX_PHP,
  "<AJAX_Request />": AJAX_Request,
  "<AJAX_Response />": AJAX_Response,
  "<AJAX_XMLHttp />": AJAX_XMLHttp,
  "<AJAX_XML_File />": AJAX_XML_File,
};

export default jsAjaxComponentsMap;
